import './alert.scss';

import { ReactNode } from 'react';

import { locator } from '../../testing/e2e-locator/locator';
import { CloseIcon } from '../Icons/CloseIcon';
import { AlertProps } from './types/AlertProps';

export const Alert = ({
  children,
  className = '',
  icon,
  onClose,
  severity,
  variant = 'standard',
  ...props
}: AlertProps): ReactNode => {
  const classNames = [
    'alert',
    variant === 'filled' && 'alert-filled',
    variant === 'standard' && `alert-${severity}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} role="alert" {...props}>
      {icon && <div className="alert-icon">{icon}</div>}
      <div className="alert-message">{children}</div>
      {onClose && (
        <div className="alert-action">
          <button
            aria-label="Close"
            className="alert-close-button"
            data-testid={locator.components.alert.closeButton}
            title="Close"
            type="button"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
      )}
    </div>
  );
};
